import type { ReactNode } from 'react';

import styles from './CitationCard.module.css';

interface CitationCardProps {
  children: ReactNode;
  doiHref: string;
  doiLabel: string;
}

export function CitationCard({ children, doiHref, doiLabel }: CitationCardProps) {
  return (
    <article className={styles.card}>
      <p className={styles.eyebrow}>PRIMARY CITATION</p>
      <cite className={styles.citation}>{children}</cite>
      <a
        className={styles.doi}
        href={doiHref}
        rel="noopener noreferrer"
        target="_blank"
      >
        {doiLabel} ↗
      </a>
    </article>
  );
}
